export default __webpack_public_path__ + "static/media/DAWjY_tMsvA.901d2b07.jpg";